import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { formatDecimal, inViewport } from '@/helpers';
import { ui } from '@/constants';

const LARGEST_NUMBER_INCLUDING_DECIMAL = 9999;

@Component({
  name: 'CmgSustainabilityInfoCard',
})
export default class CmgSustainabilityInfoCard extends Vue {
  showDrawerCopy = false;
  showTooltip = false;
  hasMobileTooltipAppeared = false;

  @Prop({ required: true, type: String })
  drawerCopy!: string;

  @Prop({ required: true, type: String })
  metricHeadline!: string;

  @Prop({ required: true, type: Number })
  metricValue!: number;

  @Prop({ required: true, type: String })
  unitOfMeasure!: string;

  @Prop({type: Boolean})
  isFirstCard?: boolean;

  get formattedMetricValue() {
    // Because numbers are uniform width in trade-gothic-bold, we can use this trick to remove the decimal point in order to show more data without it looking funky
    const formattedValue = formatDecimal(this.metricValue, 1);
    return formattedValue.toString().includes('.') && formattedValue > LARGEST_NUMBER_INCLUDING_DECIMAL ? Math.round(formattedValue) : formattedValue;
  }

  get isTabletOrSmaller(): boolean {
    const width = this.$appStore.state.ui.clientWidth;
    return width <= ui.breakpoints.tabletMax;
  }

  get tooltipAlreadyAppearedOnMobile(): boolean {
    return this.$appStore.state.customer.sustainabilityMetrics.sustainabilityTooltipAppeared;
  } 

  mounted(): void {
    if (!this.tooltipAlreadyAppearedOnMobile) {
      window.addEventListener('scroll', this.onScrollCard, true);
    }
  }

  destroyed(): void {
    window.removeEventListener('scroll', this.onScrollCard, true);
  }

  onScrollCard(): void {
    if (this.isTabletOrSmaller && this.isFirstCard && inViewport(this.$refs.sustainabilityCard as HTMLElement) && !this.tooltipAlreadyAppearedOnMobile) {
      // We only want the tooltip to show automatically on mobile once per session.
      this.$services.sustainability.setMobileSustainabilityTooltipAppeared();
      setTimeout(() => {
        window.removeEventListener('scroll', this.onScrollCard, true);
        this.showTooltip = true;
        setTimeout(() => { this.showTooltip = false; }, 3000);
      }, 2000);
    }
  }

  onClickShowDrawerCopy(): void {
    this.showDrawerCopy = true;
  }

  onClickCloseDrawer(): void {
    this.showDrawerCopy = false;
  }

  toggleDrawerCopy(): void {
    this.showDrawerCopy = !this.showDrawerCopy;
  }

  onMouseOverKebab(): void {
    if (!this.isTabletOrSmaller) {
      this.showTooltip = true;
    }
  }

  onMouseOutKebab(): void {
    if (!this.isTabletOrSmaller) {
      this.showTooltip = false;
    }
  }
}
